import { Card } from "../../../../components/ui/Card";
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from "../../../../components/Navigation/tabs";
import QuantitativeAnalysis from "./QuantitativeAnalysis";
import OpeningStructure from "./OpeningStructure";
import Brainstorming from "./Brainstorming";
import FinalRecommendation from "./FinalRecommendation";
import { DetailCaseComponentAnalysis, ComponentAnalysis } from "../../types";
import EvaluationStatus from "./components/EvaluationStatus";

interface DetailedCaseAnalysisProps {
  data: DetailCaseComponentAnalysis;
  componentAnalysis?: ComponentAnalysis;
}

const DetailedCaseAnalysis = ({
  data,
  componentAnalysis,
}: DetailedCaseAnalysisProps) => {
  // const [activeTab, setActiveTab] = useState("opening");

  return (
    <div>
      <Tabs defaultValue="opening">
        <TabsList className="mb-[1rem]">
          <TabsTrigger value="opening">Opening &amp; Structure</TabsTrigger>
          <TabsTrigger value="brainstorming">Brainstorming</TabsTrigger>
          <TabsTrigger value="quantitative">Quantitative Analysis</TabsTrigger>
          <TabsTrigger value="recommendation">Final Recommendation</TabsTrigger>
        </TabsList>
        <Card className="p-6">
          <TabsContent value="opening" className="mt-4">
            <div className="flex justify-between items-center mb-2">
              <h2 className="text-xl font-bold">Opening &amp; Structure</h2>
              {(data?.OpeningAndStructure?.status ||
                componentAnalysis?.opening_and_structure?.overallStatus) && (
                <EvaluationStatus
                  status={
                    data?.OpeningAndStructure?.status ||
                    componentAnalysis?.opening_and_structure?.overallStatus ||
                    ""
                  }
                />
              )}
            </div>
          </TabsContent>

          <TabsContent value="brainstorming" className="mt-4">
            <div className="flex justify-between items-center mb-2">
              <h2 className="text-xl font-bold">Brainstorming</h2>
              {(data?.Brainstorming?.status ||
                componentAnalysis?.brainstorming?.overallStatus) && (
                <EvaluationStatus
                  status={
                    data?.Brainstorming?.status ||
                    componentAnalysis?.brainstorming?.overallStatus ||
                    ""
                  }
                />
              )}
            </div>
          </TabsContent>

          <TabsContent value="quantitative" className="mt-4">
            <div className="flex justify-between items-center mb-2">
              <h2 className="text-xl font-bold">Quantitative Analysis</h2>
              {(data?.QuantitativeAnalysis?.status ||
                componentAnalysis?.quantitative_analysis?.overallStatus) && (
                <EvaluationStatus
                  status={
                    data?.QuantitativeAnalysis?.status ||
                    componentAnalysis?.quantitative_analysis?.overallStatus ||
                    ""
                  }
                />
              )}
            </div>
          </TabsContent>

          <TabsContent value="recommendation" className="mt-4">
            <div className="flex justify-between items-center mb-2">
              <h2 className="text-xl font-bold">Final Recommendation</h2>
              {(data?.FinalRecommendation?.status ||
                componentAnalysis?.final_recommendation?.overallStatus) && (
                <EvaluationStatus
                  status={
                    data?.FinalRecommendation?.status ||
                    componentAnalysis?.final_recommendation?.overallStatus ||
                    ""
                  }
                />
              )}
            </div>
          </TabsContent>
          <TabsContent value="opening" className="mt-6">
            {data && data.OpeningAndStructure && (
              <OpeningStructure
                data={data.OpeningAndStructure}
                componentAnalysisSection={
                  componentAnalysis?.opening_and_structure
                }
              />
            )}
            {!data && <p>No data available</p>}
          </TabsContent>

          <TabsContent value="brainstorming" className="mt-6">
            {data && data.Brainstorming && (
              <Brainstorming
                data={data.Brainstorming}
                componentAnalysisSection={componentAnalysis?.brainstorming}
              />
            )}
            {!data && <p>No data available</p>}
          </TabsContent>

          <TabsContent value="quantitative" className="mt-6">
            {data && data.QuantitativeAnalysis && (
              <QuantitativeAnalysis
                data={data.QuantitativeAnalysis}
                componentAnalysisSection={
                  componentAnalysis?.quantitative_analysis
                }
              />
            )}
            {!data && <p>No data available</p>}
          </TabsContent>

          <TabsContent value="recommendation" className="mt-6">
            {data && data.FinalRecommendation && (
              <FinalRecommendation
                data={data.FinalRecommendation}
                componentAnalysisSection={
                  componentAnalysis?.final_recommendation
                }
              />
            )}
            {!data && <p>No data available</p>}
          </TabsContent>
        </Card>
      </Tabs>
    </div>
  );
};

export default DetailedCaseAnalysis;
